import { parseWorkExperienceDateForSort } from './workExperienceSort'

/** Message shown in the validation tooltip when end is before start. */
export const EDUCATION_DATE_RANGE_ERROR_TITLE =
  'End date must be the same month as the start date or later.'

export function isEducationDateRangeInvalid(
  startDate: string | undefined,
  endDate: string | undefined
): boolean {
  const start = (startDate ?? '').trim()
  const end = (endDate ?? '').trim()
  if (!start || !end) return false

  const startTs = parseWorkExperienceDateForSort(start)
  const endTs = parseWorkExperienceDateForSort(end, { treatAsEnd: true })
  if (!startTs || !endTs) return false

  return endTs < startTs
}
